import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type {
	ApiPayload,
	EventDetailRaw,
	EventGroupListResponse,
	EventUnreadCountResponse,
} from '@/api/ApiTypes';


const eventGroupGetList = (
	showArchived: boolean,
	handler: (responseData: EventGroupListResponse) => void,
	errorHandler?: () => void,
): void => {
	axios.post('/events/group/get_list/', {
		show_archived: showArchived,
	}).then(extractData(handler)).catch(errorHandler || logError);
};


const eventGroupGetUnreadCount = (
	handler: (responseData: EventUnreadCountResponse) => void,
	errorHandler: () => void,
): void => {
	axios.get('/events/group/get_unread_count/').then(extractData(handler)).catch(errorHandler);
};


const eventGroupArchive = (
	ids: number[],
	archive: boolean,
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/events/group/archive/', { ids, archive }).then(extractData(handler)).catch(logError);
};


const eventGroupGetLastEvent = (
	eventGroupId: number,
	handler: (responseData: EventDetailRaw) => void,
	errorHandler?: () => void,
): void => {
	axios.post('/events/group/get_last_event/', { id: eventGroupId })
		.then(extractData(handler)).catch(errorHandler || logError);
};


export default {
	eventGroupGetList,
	eventGroupGetUnreadCount,
	eventGroupArchive,
	eventGroupGetLastEvent,
};
